import React from 'react'

const HtmlRawContainerBlogSection = ({ blogSectionObj }) => {

  return (
    <div className={`${blogSectionObj.attributes.sectionRendering} ${blogSectionObj.attributes.class}`}>
      <span dangerouslySetInnerHTML={{ __html: blogSectionObj.attributes.htmlRawContent }}></span>
    </div>
  )
}

export default HtmlRawContainerBlogSection
